import { useEffect } from 'react';

import { Notification } from '@mssgme/ui';

export default function useHandleError(error) {
    useEffect(() => {
        if (error) {
            Notification.danger(error, { showClose: true });
        }
    }, [error]);
}
